import React from "react";

const WinterEventSection = () => {
  return (
    <div className="column-sections pb-20">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="column-content">
            <div class="service_style_two_title pb-3 text-left">
                  <h4>Moving Beyond Traditional Alt-Data Signals</h4>
            </div>
              <p className="text-left black">During the summit, we showcased how relying solely on conventional alternative data creates blind spots for GTM, revenue, and strategy teams.
              </p>
              <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6> Intent spikes without context arrive too late.</h6>
              </div>
            </div>
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Market trends without decision ownership stay theoretical.</h6>
              </div>
            </div>
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Signals without timing rarely convert into outcomes.</h6>
              </div>
            </div>
              <p className="text-left">What’s missing is visibility into decision-making moments.<br/>
That’s where technology-driven data changes the conversation</p>

             <div class="service_style_two_title pb-3 text-left">
                  <h4>How ProPlus Data Turns Tech Decisions Into Signals</h4>
            </div>
            <p className="text-left">At Neudata Summit, we demonstrated how ProPlus Data helps teams read technology decisions as forward-looking indicators, not lagging metrics.</p>
            <p className="text-left">By combining:</p>
              <div class="col-md-12 col-lg-6 text-left">
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6><a href="https://proplusdata.co/next-tech-purchase">Next Tech Purchase®</a> insights to identify upcoming buying plans</h6>
              </div>
            </div>
            <div class="why-choose-icon " data-wow-delay=".6">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6><a href="https://proplusdata.co/technographics">Technographics</a> to understand current tech stacks and dependencies</h6>
              </div>
            </div>
            <div class="why-choose-icon" data-wow-delay=".7">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6><a href="https://proplusdata.co/renewal-intelligence">Renewal Intelligence</a> to pinpoint contract-driven decision windows</h6>
              </div>
            </div>
             
           
            {/* <div class="service_style_two_title pt-4 text-left">
                  <h6 className="w-100">One solution that sparked major interest: Next Tech Purchase®, our proprietary predictive engine that forecasts upcoming technology investments before traditional intent data can. For marketing teams, it means one thing:
                  </h6>
            </div>   */}
          
          </div>
            {/* <p className="text-left">One solution that sparked major interest: <a href="https://proplusdata.co/next-tech-purchase">Next Tech Purchase®</a> , our proprietary predictive engine that forecasts upcoming technology investments before traditional intent data can. For marketing teams, it means one thing:</p>
            <p className="text-left">A first-mover advantage on tech-buying accounts that are still off your radar.</p> */}
          <div class="service_style_two_title pt-4 text-left">
                  <h4>From Insight to Execution</h4>
            </div>
          <p className="text-left">What resonated most at Neudata Summit was not just the data itself, but its usability.
<br/> ProPlus Data is built for teams that need signals they can act on immediately.
</p>
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Signals that align sales and marketing.</h6>
              </div>
            </div>
             <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Signals that support expansion as much as acquisition.</h6>
              </div>
            </div>
             <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Signals that reduce wasted outreach and missed windows.</h6>
              </div>
            </div>
            <p className="text-left">Alternative data only matters when it improves decisions. That was the core message we delivered.</p>
          <div class="service_style_two_title pt-4 text-left">
                  <h4>From Insight to ExecutionContinuing the Conversation</h4>
            </div>
          <p className="text-left">Neudata Summit 2025 reinforced a clear shift in how leading teams think about alternative data.</p>
          <p className="text-left">The next competitive advantage will not come from more signals.
It will come from better ones.
</p>
<p className="text-left">If you missed us at the summit or want to see how technology-driven alternative data fits into your GTM or revenue strategy, we’d be happy to continue the discussion.</p>
<p className="text-left">Because tech decisions are already happening.
The question is whether you’re reading them on time.
</p>
          

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WinterEventSection;
